import { Button, Text, VStack } from '@chakra-ui/react'
import { useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Icon } from '../../../components/Icon'
import PublicFormLayout from '../../../components/publicFormLayout/PublicFormLayout'
import PersonnelMovementRequestsService from '../../../services/PersonnelMovementRequests/PersonnelMovementRequestsService'
import { PersonnelMovementBaseForm } from './PersonnelMovementBaseForm'

export default function PersonnelMovementRequestsNewPage() {
  const navigate = useNavigate()
  const [started, setStarted] = useState(false)
  const personnelMovementRequestsService = useMemo(() => new PersonnelMovementRequestsService(), [])

  if (started) {
    return (
      <PublicFormLayout title="Movimentação de Pessoal">
        <PersonnelMovementBaseForm
          submitLabel={
            <>
              Começar Solicitação &nbsp;
              <Icon name="lni lni-checkmark" />
            </>
          }
          onSubmit={async (payload) => {
            const response = await personnelMovementRequestsService.store(payload)
            navigate(`/personnel-movement/${response.data.personnel_movement_request.id}`)
          }}
        />
      </PublicFormLayout>
    )
  }

  return (
    <PublicFormLayout title="Movimentação de Pessoal">
      <VStack mb={6} spacing="4">
        <Text fontSize={{ base: 'md', md: '2xl' }} textAlign="center">
          Olá Magenta, tudo bem?
        </Text>
        <Text fontSize={{ base: 'md', md: '2xl' }} textAlign="center">
          Preencha este formulário para solicitar a Movimentação de Pessoal.
        </Text>
        <Text fontSize={{ base: 'md', md: '2xl' }} textAlign="center">
          Vamos lá?
        </Text>
        <Button colorScheme="magenta" onClick={() => setStarted(true)} w={{ base: '100%', md: 'auto' }}>
          Começar
        </Button>
      </VStack>
    </PublicFormLayout>
  )
}
